import React from "react";
import { ArrowLeft, Scale, Clock, CreditCard, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream-light py-20">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header with back button */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 text-sage-medium hover:text-gold-warm transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Voltar ao Início</span>
          </button>
          
          <div className="text-center mb-8">
            <div className="bg-aqua-soft/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Scale className="w-8 h-8 text-aqua-soft" />
            </div>
            <h1 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-4">
              Termos de Serviço
            </h1>
            <p className="text-lg text-sage-medium">
              Condições que regulam o acesso e utilização dos nossos serviços
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
          <div className="prose prose-lg max-w-none">
            <p className="text-sage-medium leading-relaxed mb-8">
              Os presentes Termos de Serviço regulam o acesso e utilização do website e serviços da <strong className="text-sage-dark">Fonte de Juvence</strong>. 
              Ao utilizar o nosso site ou efetuar uma marcação, o cliente concorda com as seguintes condições:
            </p>

            <div className="space-y-8">
              <section>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-gold-warm/20 w-10 h-10 rounded-full flex items-center justify-center">
                    <Shield className="w-5 h-5 text-gold-warm" />
                  </div>
                  <h3 className="text-2xl font-playfair font-bold text-sage-dark">1. Serviços</h3>
                </div>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full mt-2"></div>
                    <span>A Fonte de Juvence presta serviços de estética, bem-estar e rejuvenescimento, conforme descrito no website e materiais de comunicação.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full mt-2"></div>
                    <span>Os serviços estão sujeitos a marcação prévia e disponibilidade.</span>
                  </li>
                </ul>
              </section>

              <section>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-aqua-soft/20 w-10 h-10 rounded-full flex items-center justify-center">
                    <Clock className="w-5 h-5 text-aqua-soft" />
                  </div>
                  <h3 className="text-2xl font-playfair font-bold text-sage-dark">2. Marcação e Cancelamento</h3>
                </div>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-aqua-soft rounded-full mt-2"></div>
                    <span>O cliente deve comparecer no horário marcado.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-aqua-soft rounded-full mt-2"></div>
                    <span>Cancelamentos ou alterações devem ser comunicados com pelo menos <strong className="text-sage-dark">24 horas de antecedência</strong>.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-aqua-soft rounded-full mt-2"></div>
                    <span>A ausência injustificada poderá implicar custos de cancelamento.</span>
                  </li>
                </ul>
              </section>

              <section>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-sage-soft/20 w-10 h-10 rounded-full flex items-center justify-center">
                    <Shield className="w-5 h-5 text-sage-dark" />
                  </div>
                  <h3 className="text-2xl font-playfair font-bold text-sage-dark">3. Responsabilidade</h3>
                </div>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-sage-dark rounded-full mt-2"></div>
                    <span>Todos os serviços são prestados por profissionais qualificados.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-sage-dark rounded-full mt-2"></div>
                    <span>Não nos responsabilizamos por resultados diferentes das expectativas subjectivas do cliente, desde que os serviços tenham sido executados de forma correcta e profissional.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-sage-dark rounded-full mt-2"></div>
                    <span>O cliente deve informar previamente sobre quaisquer condições de saúde, alergias ou contraindicações.</span>
                  </li>
                </ul>
              </section>

              <section>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-gold-warm/20 w-10 h-10 rounded-full flex items-center justify-center">
                    <CreditCard className="w-5 h-5 text-gold-warm" />
                  </div>
                  <h3 className="text-2xl font-playfair font-bold text-sage-dark">4. Pagamentos</h3>
                </div>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full mt-2"></div>
                    <span>Os preços apresentados incluem IVA à taxa legal em vigor.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full mt-2"></div>
                    <span>O pagamento pode ser realizado em numerário, cartão ou outros métodos indicados no acto da marcação.</span>
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">5. Propriedade Intelectual</h3>
                <p className="text-sage-medium">
                  Todo o conteúdo do website (textos, imagens, logótipos, design) pertence à Fonte de Juvence e não pode ser reproduzido sem autorização.
                </p>
              </section>

              <section className="bg-cream-warm/30 rounded-2xl p-6">
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">6. Alterações</h3>
                <p className="text-sage-medium">
                  A Fonte de Juvence reserva-se o direito de atualizar estes Termos de Serviço e a Política de Privacidade, sempre que necessário. 
                  Recomenda-se a consulta regular destas páginas.
                </p>
              </section>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-2xl p-6 shadow-lg mb-6">
            <h3 className="text-xl font-playfair font-bold text-sage-dark mb-2">
              Tem alguma dúvida sobre os nossos termos?
            </h3>
            <p className="text-sage-medium mb-4">
              Entre em contacto connosco. Estamos aqui para esclarecer qualquer questão.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:253279717"
                className="bg-gold-warm text-white px-6 py-3 rounded-full hover:bg-gold-deep transition-all duration-300 font-semibold"
              >
                Ligar Agora
              </a>
              <button
                onClick={() => navigate('/')}
                className="bg-sage-dark text-white px-6 py-3 rounded-full hover:bg-sage-medium transition-all duration-300 font-semibold"
              >
                Voltar ao Website
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;